import { toast } from 'sonner'
import { i18n } from '@/shared/lib/i18n/i18n'

export function demoToast() {
  toast.info(i18n.t('demo.contactSupport'))
}
